'use client';

import { useState, useEffect } from 'react';

// Hook 用于获取屏幕宽高并自动更新
export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setScreenSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };

      // 设置初始值
      handleResize();

      // 监听窗口大小变化事件
      window.addEventListener('resize', handleResize);

      // 清除监听事件
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return screenSize;
};

export function useSVHSupport() {
  const [supportsSVH, setSupportsSVH] = useState(true);

  useEffect(() => {
    function checkSVHSupport() {
      if (typeof window !== 'undefined') {
        const div = document.createElement('div');
        div.style.height = '1svh';
        document.body.appendChild(div);
        const computedHeight = window.getComputedStyle(div).height;
        document.body.removeChild(div);
        return computedHeight !== '0px';
      }
      return true
    }

    setSupportsSVH(checkSVHSupport());
  }, []);

  return supportsSVH;
}